/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const mutateEditNodeExpectedOutgoingRevisionMax = 128;

export const mutateEditNodeTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const mutateEditNodeTypeDefinitionReferenceViewPredicatesMax = 10;

export const mutateEditNodeTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const mutateEditNodeTypeDefinitionReferenceViewSearchTermsMax = 10;

export const mutateEditNodeTypeNameMax = 200;

export const MutateEditNode = zod.object({
  contentUuid: zod
    .uuid()
    .describe(
      'The exact version being edited, as returned by GET. A stale version is a 409, not a silent replacement.',
    ),
  expectedOutgoingRevision: zod
    .string()
    .min(1)
    .max(mutateEditNodeExpectedOutgoingRevisionMax)
    .optional()
    .describe(
      'Opaque revision of a source node’s outgoing edges and TYPE policy state, as returned by GET \/content\/{lineageUuid}. Supplied here it is a precondition: the write is refused with 409 if the source has changed since. A node UUID alone is insufficient — an edge-only change does not version its source.',
    ),
  occurredAt: zod.iso.datetime({ offset: true }).optional(),
  subjectUuid: zod.uuid().optional().describe('UUID v4 identifier'),
  typeDefinition: zod
    .object({
      conformance: zod
        .enum(['open', 'lax', 'strict'])
        .optional()
        .describe(
          'open enforces slots and allows extra bodies; strict additionally rejects extra bodies; lax admits slot violations and reports them in audit. Omission preserves the stored declaration; null cannot clear it.',
        ),
      description: zod.string().nullish(),
      enums: zod
        .array(
          zod.object({
            label: zod.string(),
            value: zod.string(),
          }),
        )
        .nullish()
        .describe(
          'Ordered ENUM choices as { value, label } pairs. Both are preserved; this contract does not collapse a label into its value.',
        ),
      file: zod
        .object({
          allowedFormats: zod
            .array(
              zod.enum([
                'pdf',
                'doc',
                'docx',
                'xls',
                'xlsx',
                'csv',
                'txt',
                'jpeg',
                'png',
                'webp',
                'gif',
                'heic',
                'md',
                'html',
                'mp3',
                'm4a',
                'wav',
                'mp4',
                'mov',
                'webm',
              ]),
            )
            .min(1)
            .optional(),
        })
        .nullish(),
      metadata: zod
        .record(zod.string(), zod.unknown())
        .nullish()
        .describe(
          'Arbitrary authored metadata. Its keys are content, not command fields, and are stored and returned unaltered.',
        ),
      reference: zod
        .object({
          carbonCopy: zod.boolean().optional(),
          creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
          edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
          typeLineageUuid: zod.uuid(),
          typeUuid: zod.uuid(),
          view: zod
            .object({
              predicates: zod
                .array(
                  zod.object({
                    op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                    pathTypeUuids: zod
                      .array(zod.uuid())
                      .min(1)
                      .max(mutateEditNodeTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                    value: zod.string().optional(),
                    valueType: zod
                      .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                      .optional(),
                  }),
                )
                .max(mutateEditNodeTypeDefinitionReferenceViewPredicatesMax)
                .optional(),
              searchTerms: zod
                .array(
                  zod
                    .string()
                    .min(1)
                    .max(mutateEditNodeTypeDefinitionReferenceViewSearchTermsItemMax),
                )
                .max(mutateEditNodeTypeDefinitionReferenceViewSearchTermsMax)
                .optional(),
            })
            .nullish(),
        })
        .nullish(),
      signature: zod.looseObject({}).nullish(),
    })
    .optional(),
  typeName: zod
    .string()
    .min(1)
    .max(mutateEditNodeTypeNameMax)
    .optional()
    .describe('Rename a TYPE. Rejected on an INSTANCE.'),
  value: zod
    .object({
      booleanValue: zod.boolean().nullish(),
      dateValue: zod.string().nullish(),
      datetimeValue: zod.string().nullish(),
      jsonValue: zod.unknown().optional(),
      numericValue: zod.number().nullish(),
      stringValue: zod.string().nullish(),
    })
    .optional(),
  variant: zod
    .enum(['TYPE', 'INSTANCE'])
    .describe(
      'Asserted stored variant. Verified against storage; a mismatch is a 409. This is not a conversion request.',
    ),
});

export type MutateEditNode = zod.input<typeof MutateEditNode>;
export type MutateEditNodeOutput = zod.output<typeof MutateEditNode>;
